// DS: i4.43
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import IconWrap from '../../IconWrap';
const ShareAlike = (props)=>{
    const uniqueId = useUniqueId();
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "16",
        height: "16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#i444-${uniqueId})`
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.986 0c2.237 0 4.132.776 5.685 2.329C15.223 3.872 16 5.762 16 8c0 2.239-.762 4.114-2.286 5.629-1.61 1.58-3.52 2.371-5.728 2.371-2.162 0-4.038-.786-5.629-2.357C.786 12.07 0 10.19 0 8 0 5.82.786 3.93 2.357 2.33 3.91.776 5.786 0 7.986 0Zm.028 1.443c-1.819 0-3.357.643-4.614 1.929C2.095 4.696 1.443 6.239 1.443 8c0 1.781.647 3.314 1.942 4.6 1.296 1.296 2.838 1.943 4.629 1.943 1.78 0 3.333-.652 4.657-1.957 1.257-1.22 1.886-2.748 1.886-4.586 0-1.828-.639-3.371-1.914-4.628-1.267-1.286-2.81-1.929-4.629-1.929ZM4.443 6.871c.152-.98.547-1.74 1.185-2.278s1.414-.807 2.329-.807c1.256 0 2.257.405 3 1.214.742.81 1.114 1.848 1.114 3.114 0 1.229-.386 2.25-1.157 3.064-.772.814-1.771 1.221-3 1.221-.905 0-1.686-.27-2.343-.814-.657-.543-1.052-1.314-1.186-2.314H6.4c.047.971.633 1.457 1.757 1.457.562 0 1.014-.243 1.357-.728.344-.486.515-1.134.515-1.943 0-.848-.157-1.493-.471-1.936-.315-.443-.767-.664-1.358-.664-1.067 0-1.666.471-1.8 1.414h.586L5.401 8.457 3.814 6.87h.628Z",
        fill: "currentColor"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `i444-${uniqueId}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M0 0h16v16H0z"
    })))));
};
ShareAlike.displayName = 'ShareAlike';
export default ShareAlike;
